import { combineReducers } from 'redux';
import {
    CREATE_CHANNEL_CONTRACT_DIALOG_SHOW,
    CREATE_CHANNEL_CONTRACT_DIALOG_HIDE,
    FETCH_CHANNEL_CONTRACT_AVAILABILITY_IN_PROGRESS,
    FETCH_CHANNEL_CONTRACT_AVAILABILITY_SUCCESS,
    FETCH_CHANNEL_CONTRACT_AVAILABILITY_ERROR,
    CHANNEL_CONTRACT_USER_NAME_SET,
    CHANNEL_CONTRACT_USER_NAME_STATUS_SET,
    FETCH_CHANNEL_CONTRACT_IN_PROGRESS,
    FETCH_CHANNEL_CONTRACT_SUCCESS,
    FETCH_CHANNEL_CONTRACT_ERROR,
    FETCH_CHANNEL_CONTRACT_INFO_IN_PROGRESS,
    FETCH_CHANNEL_CONTRACT_INFO_SUCCESS,
    FETCH_CHANNEL_CONTRACT_INFO_ERROR,
    CHANNEL_CONTRACT_CHANGE_DIALOG_SHOW,
    CHANNEL_CONTRACT_CHANGE_DIALOG_HIDE,
    CHANNEL_CONTRACT_SETTINGS_TAB_SET,
    SETTINGS_CHANNEL_CONTRACT_NAME_SET,
    SETTINGS_CHANNEL_CONTRACT_DESCRIPTION_SET,
    SETTINGS_CHANNEL_CONTRACT_ADDRESS_SET,
    SETTINGS_CHANNEL_CONTRACT_ALLOW_PUBLISHERS_SET,
    SETTINGS_CHANNEL_CONTRACT_IMAGE_SET,
    CHANNEL_CONTRACT_USERNAME_SETTINGS_SET,
    CHANNEL_CONTRACT_SAVE_BUTTON_ENABLE_SET,
    FETCH_CHANNEL_ASSETS_IN_PROGRESS,
    FETCH_CHANNEL_ASSETS_SUCCESS,
    FETCH_CHANNEL_ASSETS_ERROR,
    CHANNEL_ASSETS_TAB_SET,
    CHANNEL_CONTRACT_COLLABORATION_STATUS_SET,
    CHANNEL_CONTRACT_COLLABORATION_VALUE_SET,
    REMOVE_COLLABORATORS_DIALOG_SHOW,
    REMOVE_COLLABORATORS_DIALOG_HIDE,
    ADD_NEW_COLLABORATORS,
    CHANNEL_CONTRACT_ADDRESS_FETCH_IN_PROGRESS,
    CHANNEL_CONTRACT_ADDRESS_FETCH_SUCCESS,
    CHANNEL_CONTRACT_ADDRESS_FETCH_ERROR,
    FETCH_CHANNEL_CONTRACT_IV_IN_PROGRESS,
    FETCH_CHANNEL_CONTRACT_IV_SUCCESS,
    FETCH_CHANNEL_CONTRACT_IV_ERROR,
    IS_V2_CHANNEL_PRESENT,
    SET_CHANNEL_EMPTY,
    CHANNEL_CONTRACT_DISPLAY_NAME_SET,
    SETTINGS_CHANNEL_CONTRACT_BANNER_SET,
    CHANNEL_PAGE_TAB_VALUE_SET,
    CHANNEL_PAGE_SUB_TAB_VALUE_SET,
    FETCH_CHANNEL_CONTRACT_VOD_IN_PROGRESS,
    FETCH_CHANNEL_CONTRACT_VOD_SUCCESS,
    FETCH_CHANNEL_CONTRACT_VOD_ERROR,
    FETCH_CONTRACT_INTERACTIVE_VIDEOS_IN_PROGRESS,
    FETCH_CONTRACT_INTERACTIVE_VIDEOS_SUCCESS,
    FETCH_CONTRACT_INTERACTIVE_VIDEOS_ERROR,
    FETCH_CONTRACT_VIDEO_MINTS_IN_PROGRESS,
    FETCH_CONTRACT_VIDEO_MINTS_SUCCESS,
    FETCH_CONTRACT_VIDEO_MINTS_ERROR,
    FETCH_CONTRACT_GATED_IV_IN_PROGRESS,
    FETCH_CONTRACT_GATED_IV_ERROR,
    FETCH_CONTRACT_GATED_IV_SUCCESS,
    FETCH_CONTRACT_VIDEO_DROPS_IN_PROGRESS,
    FETCH_CONTRACT_VIDEO_DROPS_SUCCESS,
    FETCH_CONTRACT_VIDEO_DROPS_ERROR,
    FETCH_CONTRACT_UPCOMING_IV_IN_PROGRESS,
    FETCH_CONTRACT_UPCOMING_IV_SUCCESS,
    FETCH_CONTRACT_UPCOMING_IV_ERROR,
    SET_VIDEOS_LIST_EMPTY,
    FETCH_CHANNEL_LIVE_STREAMS_IN_PROGRESS,
    FETCH_CHANNEL_LIVE_STREAMS_SUCCESS,
    FETCH_CHANNEL_LIVE_STREAMS_ERROR,
    FETCH_CHANNEL_VIDEOS_STATS_IN_PROGRESS,
    FETCH_CHANNEL_VIDEOS_STATS_SUCCESS,
    FETCH_CHANNEL_VIDEOS_STATS_ERROR,
    SET_CHANNEL_IV_SEARCH,
    DISCARD_CHANGES_DIALOG_HIDE,
    DISCARD_CHANGES_DIALOG_SHOW,
} from '../../constants/channelContract';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../config';
import { DISCONNECT_SET } from '../../constants/account';
import _createChannel from './createChannel';

const createChannelContractDialog = (state = {
    open: false,
}, action) => {
    switch (action.type) {
    case CREATE_CHANNEL_CONTRACT_DIALOG_SHOW:
        return {
            open: true,
        };
    case CREATE_CHANNEL_CONTRACT_DIALOG_HIDE:
        return {
            open: false,
        };
    default:
        return state;
    }
};

const channelContractAvailability = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case FETCH_CHANNEL_CONTRACT_AVAILABILITY_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CHANNEL_CONTRACT_AVAILABILITY_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case FETCH_CHANNEL_CONTRACT_AVAILABILITY_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const channelContractDisplayName = (state = '', action) => {
    if (action.type === CHANNEL_CONTRACT_DISPLAY_NAME_SET) {
        return action.value;
    } else if (action.type === CREATE_CHANNEL_CONTRACT_DIALOG_HIDE) {
        return '';
    }

    return state;
};

const channelContractUserName = (state = '', action) => {
    if (action.type === CHANNEL_CONTRACT_USER_NAME_SET) {
        return action.value;
    } else if (action.type === CREATE_CHANNEL_CONTRACT_DIALOG_HIDE) {
        return '';
    }

    return state;
};

const channelContractUsernameStatus = (state = true, action) => {
    if (action.type === CHANNEL_CONTRACT_USER_NAME_STATUS_SET) {
        return action.value;
    } else if (action.type === CREATE_CHANNEL_CONTRACT_DIALOG_HIDE) {
        return true;
    }

    return state;
};

const channelContractsList = (state = {
    inProgress: false,
    value: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case FETCH_CHANNEL_CONTRACT_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CHANNEL_CONTRACT_SUCCESS:
        if (action.skip === DEFAULT_SKIP) {
            return {
                ...state,
                inProgress: false,
                value: action.value,
                skip: action.limit - DEFAULT_LIMIT,
                limit: DEFAULT_LIMIT,
                total: action.total,
            };
        } else {
            return {
                ...state,
                inProgress: false,
                value: [...state.value, ...action.value],
                skip: action.skip,
                limit: action.limit,
                total: action.total,
            };
        }
    case FETCH_CHANNEL_CONTRACT_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case SET_CHANNEL_EMPTY:
        return {
            ...state,
            value: [],
        };

    default:
        return state;
    }
};

const channelContractInfo = (state = {
    inProgress: false,
    value: {},
}, action) => {
    switch (action.type) {
    case FETCH_CHANNEL_CONTRACT_INFO_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CHANNEL_CONTRACT_INFO_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case FETCH_CHANNEL_CONTRACT_INFO_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case DISCONNECT_SET:
    case SET_CHANNEL_EMPTY:
        return {
            ...state,
            value: {},
        };
    default:
        return state;
    }
};

const channelContractChangeDialog = (state = {
    open: false,
    value: {},
}, action) => {
    switch (action.type) {
    case CHANNEL_CONTRACT_CHANGE_DIALOG_SHOW:
        return {
            open: true,
            value: action.value,
        };
    case CHANNEL_CONTRACT_CHANGE_DIALOG_HIDE:
        return {
            open: false,
            value: {},
        };

    default:
        return state;
    }
};

const channelContractSettingsTab = (state = 'general', action) => {
    if (action.type === CHANNEL_CONTRACT_SETTINGS_TAB_SET) {
        return action.value;
    }

    return state;
};

const settingsChannelContractName = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case SETTINGS_CHANNEL_CONTRACT_NAME_SET:
        return {
            value: action.value,
        };
    case FETCH_CHANNEL_CONTRACT_INFO_SUCCESS:
        return {
            value: action.value && action.value.channel_name,
        };

    default:
        return state;
    }
};

const settingsChannelContractDescription = (state = {
    value: '',
    valid: true,
}, action) => {
    switch (action.type) {
    case SETTINGS_CHANNEL_CONTRACT_DESCRIPTION_SET:
        return {
            value: action.value,
            valid: action.valid,
        };
    case FETCH_CHANNEL_CONTRACT_INFO_SUCCESS:
        return {
            value: action.value && action.value.description,
            valid: true,
        };

    default:
        return state;
    }
};

const settingsChannelContractAddress = (state = {
    value: [],
    switch: false,
}, action) => {
    switch (action.type) {
    case SETTINGS_CHANNEL_CONTRACT_ADDRESS_SET:
        return {
            ...state,
            value: action.value,
        };
    case SETTINGS_CHANNEL_CONTRACT_ALLOW_PUBLISHERS_SET:
        return {
            ...state,
            switch: action.value,
        };
    case FETCH_CHANNEL_CONTRACT_INFO_SUCCESS:
        return {

            ...state,
            value: action.value && action.value.publishers,
            switch: !!(action.value && action.value.publishers && action.value.publishers.length),
        };

    default:
        return state;
    }
};

const settingsChannelContractImage = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case SETTINGS_CHANNEL_CONTRACT_IMAGE_SET:
        return {
            value: action.value,
        };
    case FETCH_CHANNEL_CONTRACT_INFO_SUCCESS:
        return {
            value: action.value && action.value.profile_picture,
            valid: true,
        };

    default:
        return state;
    }
};

const settingsChannelContractBanner = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case SETTINGS_CHANNEL_CONTRACT_BANNER_SET:
        return {
            value: action.value,
        };
    case FETCH_CHANNEL_CONTRACT_INFO_SUCCESS:
        return {
            value: action.value && action.value.banner_picture,
            valid: true,
        };

    default:
        return state;
    }
};

const channelContractUserNameSettings = (state = '', action) => {
    if (action.type === CHANNEL_CONTRACT_USERNAME_SETTINGS_SET) {
        return action.value;
    } else if (action.type === FETCH_CHANNEL_CONTRACT_INFO_SUCCESS) {
        return (action.value && (action.value.username || action.value.custom_id)) || '';
    }

    return state;
};

const channelContractCollaboration = (state = {
    status: false,
    value: [],
}, action) => {
    switch (action.type) {
    case CHANNEL_CONTRACT_COLLABORATION_STATUS_SET: {
        if (action.value && state.value && Object.keys(state.value).length === 0) {
            return {
                status: action.value,
                value: [{
                    address: action.address,
                    role: action.role,
                    weight: '100',
                }],
            };
        } else if (!action.value) {
            return {
                ...state,
                status: action.value,
            };
        } else {
            return {
                ...state,
                status: action.value,
            };
        }
    }
    case CHANNEL_CONTRACT_COLLABORATION_VALUE_SET:
        return {
            ...state,
            value: action.value,
        };
    default:
        return state;
    }
};

const addNewCollaborators = (state = {
    value: [],
}, action) => {
    switch (action.type) {
    case ADD_NEW_COLLABORATORS:
        return {
            value: action.value,
        };

    default:
        return state;
    }
};

const removeCollaboratorsDialog = (state = {
    open: false,
    value: null,
}, action) => {
    switch (action.type) {
    case REMOVE_COLLABORATORS_DIALOG_SHOW:
        return {
            open: true,
            value: action.value,
        };
    case REMOVE_COLLABORATORS_DIALOG_HIDE:
        return {
            open: false,
        };
    default:
        return state;
    }
};

const channelContractSaveButtonEnable = (state = false, action) => {
    switch (action.type) {
    case CHANNEL_CONTRACT_SAVE_BUTTON_ENABLE_SET:
        return action.value;
    default:
        return state;
    }
};

const channelAssets = (state = {
    inProgress: false,
    value: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case FETCH_CHANNEL_ASSETS_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CHANNEL_ASSETS_SUCCESS:
        if (action.skip === DEFAULT_SKIP) {
            return {
                ...state,
                inProgress: false,
                value: action.value,
                skip: action.limit - DEFAULT_LIMIT,
                limit: DEFAULT_LIMIT,
                total: action.total,
            };
        } else {
            return {
                ...state,
                inProgress: false,
                value: [...state.value, ...action.value],
                skip: action.skip,
                limit: action.limit,
                total: action.total,
            };
        }
    case FETCH_CHANNEL_ASSETS_ERROR:
        return {
            ...state,
            inProgress: false,
        };

    default:
        return state;
    }
};

const channelAssetsTab = (state = {
    value: 'iv_videos',
}, action) => {
    switch (action.type) {
    case CHANNEL_ASSETS_TAB_SET:
        return {
            value: action.value,
        };

    default:
        return state;
    }
};

const channelContractAddress = (state = {
    value: {},
    inProgress: false,
}, action) => {
    switch (action.type) {
    case CHANNEL_CONTRACT_ADDRESS_FETCH_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case CHANNEL_CONTRACT_ADDRESS_FETCH_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case CHANNEL_CONTRACT_ADDRESS_FETCH_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    default:
        return state;
    }
};

const channelContractIV = (state = {
    inProgress: false,
    value: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case FETCH_CHANNEL_CONTRACT_IV_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CHANNEL_CONTRACT_IV_SUCCESS:
        return {
            ...state,
            inProgress: false,
            value: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    case FETCH_CHANNEL_CONTRACT_IV_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case SET_VIDEOS_LIST_EMPTY:
        return {
            ...state,
            value: [],
        };

    default:
        return state;
    }
};

const channelContractVODs = (state = {
    inProgress: false,
    value: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case FETCH_CHANNEL_CONTRACT_VOD_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CHANNEL_CONTRACT_VOD_SUCCESS:
        return {
            ...state,
            inProgress: false,
            value: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    case FETCH_CHANNEL_CONTRACT_VOD_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case SET_VIDEOS_LIST_EMPTY:
        return {
            ...state,
            value: [],
        };

    default:
        return state;
    }
};

const contractInteactiveVideosList = (state = {
    inProgress: false,
    value: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case FETCH_CONTRACT_INTERACTIVE_VIDEOS_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CONTRACT_INTERACTIVE_VIDEOS_SUCCESS:
        return {
            ...state,
            inProgress: false,
            value: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    case FETCH_CONTRACT_INTERACTIVE_VIDEOS_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case SET_VIDEOS_LIST_EMPTY:
        return {
            ...state,
            value: [],
        };

    default:
        return state;
    }
};

const contractVideoMints = (state = {
    inProgress: false,
    value: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case FETCH_CONTRACT_VIDEO_MINTS_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CONTRACT_VIDEO_MINTS_SUCCESS:
        return {
            ...state,
            inProgress: false,
            value: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    case FETCH_CONTRACT_VIDEO_MINTS_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case SET_VIDEOS_LIST_EMPTY:
        return {
            ...state,
            value: [],
        };

    default:
        return state;
    }
};

const contractGatedIV = (state = {
    inProgress: false,
    value: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case FETCH_CONTRACT_GATED_IV_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CONTRACT_GATED_IV_SUCCESS:
        return {
            ...state,
            inProgress: false,
            value: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    case FETCH_CONTRACT_GATED_IV_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case SET_VIDEOS_LIST_EMPTY:
        return {
            ...state,
            value: [],
        };

    default:
        return state;
    }
};

const contractVideoDrops = (state = {
    inProgress: false,
    value: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case FETCH_CONTRACT_VIDEO_DROPS_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CONTRACT_VIDEO_DROPS_SUCCESS:
        return {
            ...state,
            inProgress: false,
            value: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    case FETCH_CONTRACT_VIDEO_DROPS_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case SET_VIDEOS_LIST_EMPTY:
        return {
            ...state,
            value: [],
        };

    default:
        return state;
    }
};

const contractUpcomingIV = (state = {
    inProgress: false,
    value: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case FETCH_CONTRACT_UPCOMING_IV_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CONTRACT_UPCOMING_IV_SUCCESS:
        return {
            ...state,
            inProgress: false,
            value: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    case FETCH_CONTRACT_UPCOMING_IV_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case SET_VIDEOS_LIST_EMPTY:
        return {
            ...state,
            value: [],
        };

    default:
        return state;
    }
};

const channelLiveStreams = (state = {
    inProgress: false,
    value: [],
    skip: DEFAULT_SKIP,
    limit: DEFAULT_LIMIT,
    total: null,
}, action) => {
    switch (action.type) {
    case FETCH_CHANNEL_LIVE_STREAMS_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CHANNEL_LIVE_STREAMS_SUCCESS:
        return {
            ...state,
            inProgress: false,
            value: action.value,
            skip: action.skip,
            limit: action.limit,
            total: action.total,
        };
    case FETCH_CHANNEL_LIVE_STREAMS_ERROR:
        return {
            ...state,
            inProgress: false,
        };
    case SET_VIDEOS_LIST_EMPTY:
        return {
            ...state,
            value: [],
        };

    default:
        return state;
    }
};

const isV2Channel = (state = {
    value: false,
}, action) => {
    switch (action.type) {
    case IS_V2_CHANNEL_PRESENT:
        return {
            value: action.value,
        };

    default:
        return state;
    }
};

const tabValue = (state = {
    value: 'videos',
}, action) => {
    switch (action.type) {
    case CHANNEL_PAGE_TAB_VALUE_SET:
        return {
            value: action.value,
        };

    default:
        return state;
    }
};

const subTabValue = (state = {
    value: 'all',
}, action) => {
    switch (action.type) {
    case CHANNEL_PAGE_SUB_TAB_VALUE_SET:
        return {
            value: action.value,
        };

    default:
        return state;
    }
};

const channelVideosStats = (state = {
    inProgress: false,
    value: {},
}, action) => {
    switch (action.type) {
    case FETCH_CHANNEL_VIDEOS_STATS_IN_PROGRESS:
        return {
            ...state,
            inProgress: true,
        };
    case FETCH_CHANNEL_VIDEOS_STATS_SUCCESS:
        return {
            inProgress: false,
            value: action.value,
        };
    case FETCH_CHANNEL_VIDEOS_STATS_ERROR:
        return {
            ...state,
            inProgress: false,
        };

    default:
        return state;
    }
};

const channelIVSearch = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case SET_CHANNEL_IV_SEARCH:
        return {
            value: action.value,
        };

    default:
        return state;
    }
};

const DiscardChangesDialog = (state = {
    open: false,
}, action) => {
    switch (action.type) {
    case DISCARD_CHANGES_DIALOG_SHOW:
        return {
            open: true,
        };
    case DISCARD_CHANGES_DIALOG_HIDE:
        return {
            open: false,
        };
    default:
        return state;
    }
};

export default combineReducers({
    createChannelContractDialog,
    channelContractAvailability,
    channelContractUserName,
    channelContractUsernameStatus,
    channelContractDisplayName,
    channelContractsList,
    channelContractInfo,
    channelContractChangeDialog,

    channelContractSettingsTab,

    settingsChannelContractName,
    settingsChannelContractDescription,
    settingsChannelContractAddress,

    settingsChannelContractImage,
    settingsChannelContractBanner,
    channelContractUserNameSettings,
    channelContractCollaboration,
    addNewCollaborators,
    removeCollaboratorsDialog,
    channelContractSaveButtonEnable,

    channelAssets,
    channelAssetsTab,

    channelContractAddress,

    channelContractIV,
    channelContractVODs,
    contractInteactiveVideosList,
    contractVideoMints,
    contractGatedIV,
    contractVideoDrops,
    contractUpcomingIV,
    channelLiveStreams,
    channelIVSearch,

    isV2Channel,
    tabValue,
    subTabValue,

    create: _createChannel,
    channelVideosStats,
    DiscardChangesDialog,
});
